<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Row type="flex" :gutter="gutterItem">
        <Col :span="ItemCol" class="basic_item">
          <span class="basic_title">{{ $t('key1002224') }}</span>
          <span class="basic_txt">{{ defaultCurrency() }}</span>
        </Col>
        <Col :span="ItemCol" class="basic_item">
          <span class="basic_title">{{ $t('key1002225') }}</span>
          <div class="currency_box">
            <span v-if="supplierCurrencyList.length>0">{{ supplierCurrencyList.join('、') }}</span>
            <span class="themeColor cursor ml20" @click="$refs['changeCurrency'].initCurrencyData('addSupplier')">{{ $t('key1002226') }}</span>
          </div>
        </Col>
        <Col :span="ItemCol" class="basic_item">
          <span class="basic_title">{{ $t('key1002227') }}</span>
          <div class="currency_box">
            <span v-if="distributorCurrencyList.length>0">{{ distributorCurrencyList.join('、') }}</span>
            <span class="themeColor cursor ml20" @click="$refs['changeCurrency'].initCurrencyData('addDistributor')">{{ $t('key1002226') }}</span>
          </div>
        </Col>
      </Row>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        :loading="tableLoading"
        border
        max-height="600"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--底部操作按钮-->
    <div class="options_content">
      <div class="flex align-items-center" v-if="editExchangeRate">
        <Button class="mr15" @click="cancelBtn">{{ $t('key1000112') }}</Button>
        <Button class="mr15" type="primary" @click="saveExchangeRate" v-if="getPermission('exchangeRate_settingUpdateRate')">{{ $t('key1000555') }}</Button>
      </div>
      <Button class="mr15" type="primary" v-if="getPermission('exchangeRate_settingUpdateRate') && !editExchangeRate"
        :disabled="tableData.length <=0" @click="editExchangeRateBtn">{{ $t('key1000985') }}</Button>
    </div>
    <!--添加币种弹窗-->
    <changeCurrencyModal ref="changeCurrency" @updateData="updateData"></changeCurrencyModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import changeCurrencyModal from "@/components/common/changeCurrencyModal";
import {amountHandel, currencyNameCode, getCurrencyData} from "@/utils/common";

export default {
  name: "exchangeRateConfig",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 24,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002208'),
          key: 'platformCurrency',
          align: 'center',
          render(h, params) {
            let text = currencyNameCode(v.currencyState);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002209'),
          key: 'transactionCurrency',
          align: 'center',
          render(h, params) {
            let text = params.row.currencyName + ' ' + params.row.targetCurrencyCode;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002210'),
          key: 'config',
          align: 'center',
          render(h, params) {
            let rateType = params.row.rateType;
            return h('RadioGroup', {
              props: {
                value: rateType,
              },
              on: {
                'on-change': value => {
                  v.$set(v.tableData[params.index], 'rateType', value);
                }
              }
            }, [
              h('Radio', {
                props: {
                  label: 1,
                  disabled: !v.editExchangeRate
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002211')),
              h('Radio', {
                class: 'ml30',
                props: {
                  label: 2,
                  disabled: !v.editExchangeRate
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002212'))
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002213'),
          key: 'floatingScale',
          align: 'center',
          render(h, params) {
            let rateType = params.row.rateType === 1;
            let floatType = params.row.floatType;
            let floatTypeList = [
              {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001047')},
              {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002214')},
            ];
            return h('div', {class: 'flex justify-content-center'}, [
              h('Input', {
                props: {
                  value: params.row.merchantExchangeRate,
                  placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002215'),
                  disabled: !v.editExchangeRate
                },
                style: {
                  width: '200px',
                  display: rateType ? 'inline-table' : 'none'
                },
                on: {
                  input: (val) => {
                    v.$set(v.tableData[params.index], 'merchantExchangeRate', val.trim());
                  }
                }
              }),
              h('Input', {
                props: {
                  value: params.row.floatRate,
                  placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002216'),
                  disabled: !v.editExchangeRate
                },
                style: {
                  width: '200px',
                  display: !rateType ? 'inline-table' : 'none'
                },
                on: {
                  input: (val) => {
                    v.$set(v.tableData[params.index], 'floatRate', val.trim());
                  }
                }
              }, [
                h('div', {
                  slot: 'append',
                }, '%'),
                h('Select', {
                  slot: 'prepend',
                  props: {
                    value: floatType,
                    transfer: true,
                    disabled: !v.editExchangeRate
                  },
                  style: {
                    width: '60px'
                  },
                  on: {
                    'on-change'(e) {
                      v.$set(v.tableData[params.index], 'floatType', e);
                    }
                  }
                }, floatTypeList.map(i => {
                  return h('Option', {
                    props: {
                      value: i.value
                    }
                  }, i.name);
                }))
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002217'),
          key: 'exchangeRateValue',
          align: 'center',
          render(h, params) {
            let targetCurrencyCode = params.row.targetCurrencyCode;
            let merchantExchangeRate = 0;
            let officialExchangeRate = 0;
            merchantExchangeRate = amountHandel(1 / params.row.merchantExchangeRate, 4);
            officialExchangeRate = amountHandel(1 / params.row.officialExchangeRate, 4);
            let realExchangeRateValue = '1 CNY = ' + officialExchangeRate + ' ' + targetCurrencyCode;
            let systemExchangeRateValue = '1 CNY = ' + merchantExchangeRate + ' ' + targetCurrencyCode;
            return h('div', {
              style: {
                width: '300px',
                textAlign: 'left'
              }
            }, [
              h('p', {class: 'mt5 mb5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002218') + realExchangeRateValue),
              h('p', {class: 'mt5 mb5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002219') + systemExchangeRateValue)
            ]);
          }
        }
      ],
      tableData: [],
      supplierCurrencyList: [], // 供应商币种
      distributorCurrencyList: [], // 分销商币种
      editExchangeRate: false,
      editOriginalData: []
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 平台默认币种
    defaultCurrency() {
      let currency = this.currencyState;
      return currencyNameCode(currency) || '';
    },
    // 初始化接口数据
    initFun() {
      (async () => {
        await getCurrencyData();
        await this.systemCurrencyData(2);
        await this.systemCurrencyData(3);
        await this.getList();
      })();
    },
    // 获取对应系统设置的币种
    systemCurrencyData(merchantType) {
      let v = this;
      let obj = {
        2: 'supplierCurrencyList',
        3: 'distributorCurrencyList'
      };
      v.axios.get(api.get_ymsCurrencyConfig_query + `?merchantType=${merchantType}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            let list = data.map((item) => {
              item.currencyNameCode = item.currencyName + ' ' + item.targetCurrencyCode;
              return item.currencyNameCode;
            });
            v[obj[merchantType]] = v.uniqueFunc(list);
          }
        }
      });
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableLoading = true;
      v.tableData = [];
      v.axios.get(api.get_ymsCurrencyConfig_query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            data.map((item) => {
              if (item.floatRate) {
                let value = amountHandel(item.floatRate * 100, 4);
                item.floatRate = Number(value);
              }
            });
          }
          v.tableData = data || [];
          v.$nextTick(() => {
            v.tableLoading = false;
          });
        } else {
          v.tableLoading = false;
        }
      });
    },
    // 取消
    cancelBtn() {
      let v = this;
      v.editExchangeRate = false;
      v.tableData = JSON.parse(JSON.stringify(v.editOriginalData));
    },
    // 编辑汇率配置
    editExchangeRateBtn() {
      let v = this;
      v.editExchangeRate = true;
      v.editOriginalData = JSON.parse(JSON.stringify(v.tableData));
    },
    // 保存汇率配置
    saveExchangeRate() {
      let v = this;
      let reg = v.$regular.hasPriceNum;
      let queryList = [];
      for (let i = 0; i < v.tableData.length; i++) {
        let item = v.tableData[i];
        if (item.rateType === 1) {
          if (item.merchantExchangeRate === '') {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002220'));
            return false;
          } else {
            let merchantExchangeRate = Number(item.merchantExchangeRate);
            if (!reg.test(merchantExchangeRate)) {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002221'));
              return false;
            }
          }
        } else {
          if (item.floatRate === '') {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002222'));
            return false;
          } else {
            let floatRate = Number(item.floatRate);
            if (!reg.test(floatRate)) {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002223'));
              return false;
            }
          }
        }
        let floatRate = amountHandel(Number(item.floatRate) / 100, 4);
        queryList.push({
          floatRate: Number(floatRate),
          floatType: item.floatType,
          officialExchangeRate: Number(item.officialExchangeRate),
          rateType: item.rateType,
          targetCurrencyCode: item.targetCurrencyCode,
          merchantExchangeRate: item.merchantExchangeRate
        });
      }
      v.axios.post(api.post_exchangeRate_settingUpdateRate, queryList, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.getList();
          v.editExchangeRate = false;
        }
      });
    },
    // 更新数据
    updateData(merchantType) {
      this.systemCurrencyData(merchantType);
      this.getList();
    }
  },
  components: {
    changeCurrencyModal
  }
};
</script>

<style lang="less" scoped>
.container_box {
  padding-bottom: 60px;

  .operation_box {

    .basic_item {
      width: 100%;
      margin-bottom: 12px;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;

      &:last-child {
        margin-bottom: 0;
      }

      .basic_title {
        width: 80px;
        text-align: right;
        color: #333;
        font-weight: bold;
      }

      .basic_txt {
        color: #666;
      }

      .currency_box {
        flex: 1;
        overflow: hidden;
      }
    }
  }

  .options_content {
    box-shadow: 0px -3px 10px 0px #c9cbce;
    position: fixed;
    min-width: 100%;
    z-index: 10;
    background-color: #fff;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 15px;
  }
}
</style>